/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames = require("classnames");
var PropTypes = require("prop-types");
var Icon_1 = require("./Icon");
var CountryFlag_1 = require("./CountryFlag");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./CountrySelectionList.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-countrySelectionList");
/* Todo: Refactor, to use with <Media/> */
exports.CountrySelectionList = function CountrySelectionList(_a) {
    var children = _a.children, inline = _a.inline;
    return (React.createElement("ul", { className: classnames(moduleClassName(), !!inline && moduleClassName("isInline")) }, children));
};
exports.CountrySelectionListItem = function CountrySelectionListItem(props) {
    // eslint-disable-line react/no-multi-comp
    var arrow = props.arrow, _a = props.arrowType, arrowType = _a === void 0 ? "arrow-right" : _a, flag = props.flag, onClick = props.onClick, market = props.market, url = props.url, _b = props.check, check = _b === void 0 ? false : _b;
    return (React.createElement("li", null,
        React.createElement("a", { href: "#", onClick: function (e) {
                e.preventDefault();
                return onClick(e);
            }, className: classnames(check ? moduleClassName("isChecked") : 0) },
            React.createElement(CountryFlag_1.CountryFlag, { type: flag }),
            React.createElement("div", { className: moduleClassName("country") },
                React.createElement("span", { className: moduleClassName("countryMarket") }, market),
                !!url && (React.createElement("span", { className: moduleClassName("countryURL") }, url))),
            check && React.createElement(Icon_1.Icon, { type: "check", color: "metro-blue", size: 1.5 }),
            arrow && React.createElement(Icon_1.Icon, { type: arrowType, color: "blue" }))));
};
exports.CountrySelectionListItem.propTypes = {
    flag: PropTypes.oneOf(Object.keys(CountryFlag_1.flagTypes)).isRequired,
    market: PropTypes.string.isRequired,
    url: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    arrow: PropTypes.bool,
    arrowType: PropTypes.oneOf(["arrow-right", "select"]),
    check: PropTypes.bool
};
exports.CountrySelectionListItem.defaultProps = {
    arrowType: "arrow-right",
    check: false
};
exports.CountrySelectionListFooter = function CountrySelectionListFooter(_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { className: classnames(moduleClassName("footer"), className) }, children));
};